import { render, staticRenderFns } from "./CardStyle8.vue?vue&type=template&id=521e7a14"
import script from "./CardStyle8.vue?vue&type=script&lang=js"
export * from "./CardStyle8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports